<template>
  <div class="layout-left">
		<div class="module module-1">
			<title-bar title="营业概况"></title-bar>
			<div class="module-content">
				<div id="echartA" class="echart-a"></div>
			</div>
		</div>
		<div class="module module-2">
			<title-bar title="用电量概况"></title-bar>
			<div class="module-content">
				<div id="echartB" class="echart-a"></div>
			</div>
		</div>
	</div>
</template>

<script>
import * as echarts from 'echarts'
import TitleBar from './title-bar.vue'


export default {
	components: { TitleBar },

	mounted() {
		this.eChartInitA()
		this.eChartInitB()
	},

	methods: {
		eChartInitA() {
			let chartDom = document.getElementById('echartA')
			let myChart = echarts.init(chartDom)
			let option

			let xAxisData = []
			let data1 = []
			let data2 = []
			let data3 = []
			for (let i = 0; i < 7 ;i++) {
				xAxisData.push('Day' + (i + 1))
				data1.push(+(Math.random() * 3000).toFixed(2))
				data2.push(+(Math.random() * 4000).toFixed(2))
				data3.push(+(Math.random() + 1000).toFixed(2))
			}
			console.log('xAxisData', xAxisData)
			let emphasisStyle = {
				itemStyle: {
					shadowBlur: 10,
					shadowColor: 'rgba(0,0,0,0.3)'
				}
			}
			option = {
				color: ['#009DFF', '#11CABE', '#FE8A00'],
				legend: {
					data: ['充值恢复', '套餐卡收益', '充电收益'],
					bottom: '20',
					textStyle: {
						color: '#fff'
					}
				},
				tooltip: {},
				xAxis: {
					data: xAxisData,
				},
				yAxis: {},
				grid: {
					top: 20,
					left: 40,
					bottom: 75
				},
				series: [
					{
						name: '充值恢复',
						type: 'bar',
						stack: 'total',
						emphasis: emphasisStyle,
						data: data1
					},
					{
						name: '套餐卡收益',
						type: 'bar',
						stack: 'total',
						emphasis: emphasisStyle,
						data: data2
					},
					{
						name: '充电收益',
						type: 'bar',
						stack: 'total',
						emphasis: emphasisStyle,
						data: data3
					},
				]
			}

			option && myChart.setOption(option)
		},
		eChartInitB() {
			let chartDom = document.getElementById('echartB')
			let myChart = echarts.init(chartDom)
			let option

			option = {
				color: ['#00E074'],
				tooltip: {},
				xAxis: {
					type: 'category',
					data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
				},
				yAxis: {
					type: 'value'
				},
				grid: {
					top: 20,
					bottom: 40,
				},
				series: [
					{
						data: [150, 230, 224, 218, 135, 147, 260],
						type: 'line'
					}
				]
			}

			option && myChart.setOption(option)
		}
	}
}
</script>

<style lang="scss" scoped>
.layout-left {
	width: 400px;
	.module {
		margin-bottom: 30px;
		.module-content {
			margin-top: 20px;
			width: 100%;
			height: 256px;
			background: #141518;
			.echart-a {
				width: 100%;
				height: 256px;
			}
		}
	}
}

</style>
